import { gql } from "@apollo/client";

export const MainDashboardQuery = gql`
query MyQuery(
  $id: String
) {
  aatmsv4_register(where: {userid: {_eq: $id}, active: {_eq: true}}) {
    active
    aircraft
    birthdate
    client {
      clientname
      contactemail
      contactperson
      department
      landingmessage
      logo
      ranks {
        rank
      }
    }
    dataadmin
    crew
    ecode
    emailofficial
    ground
    optimiser
    simulator
    photo
    managers
    name
  }
}

`
